import { Button, CircularProgress, Grid } from '@mui/material';
import _ from 'lodash';

import * as S from './styles';

export default function AxlConfirmation({
  onClose = () => {/* empty */},
  onDo = () => {/* empty */},
  title = 'CONFIRMATION',
  subTitle,
  closeText = 'Cancel',
  doText = 'Save',
  controlTextAlign = 'center',
  loading = false,
  disabled = false,
  style = {},
  ...props
}) {

  return (
      <S.ResolvedContainer style={style}>
        <S.TitleModal>{title}</S.TitleModal>
        <S.SubTitleModal>{subTitle}</S.SubTitleModal>
        <Grid container justifyContent={controlTextAlign} alignItems={'center'} pt={2} gap={2}>
          <Button onClick={onClose} size='small' variant='outlined' disableElevation {...props.closeProps}>
            {closeText}
          </Button>
          <Button onClick={onDo} size='small' variant='contained' color='primary' disableElevation {...props.doProps}>
            {loading ? <CircularProgress size={15} thickness={1} /> : doText}
          </Button>
        </Grid>
      </S.ResolvedContainer>
  );
}
